import React, { useState, useCallback, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import p2 from "../../assets/p5.png";
import "../../profiledetails.css";
import { getProfileById, viewContact } from "../../store/slices/preference";
import { IoIosArrowDropleft, IoIosArrowDropright, IoIosCloseCircle } from "react-icons/io";
import { Container } from "react-bootstrap";
import { toast } from "react-toastify";
import { searchProfile } from "../../store/slices/preference";


export default function ProfileDetails() {
  const { id } = useParams();

  const dispatch = useDispatch();

  const { profileDetails, profileLoading, searchResults = [], } = useSelector(
    (state) => state.preference,
  );

  const { profilelist = {} } = useSelector((state) => state.profile);

  useEffect(() => {
    if (id) {
      const item = { id };
      dispatch(getProfileById(item));
    }
  }, [id]);

  useEffect(() => {
    dispatch(
      searchProfile({
        page: 1,
        limit: 2,
      })
    );
  }, [dispatch]);


  const profile = profileDetails || {};
  const [contactNumber, setContactNumber] = useState(profile?.mobileNumber || "");
  const [loadingContact, setLoadingContact] = useState(false);

  const profileInfo = profile?.profile || {};
  const profession = profile?.profession || {};
  const family = profile?.family || {};
  const siblingsData = family?.siblings || {};

  const extraPhotos = Array.isArray(profileInfo?.photos) ? profileInfo.photos : [];
  const allPhotos = [profile?.profilePhoto, ...extraPhotos].filter(Boolean);
  const photos = allPhotos.length > 0 ? allPhotos : [];
  const [index, setIndex] = useState(0);


  const profileFor = profile?.profileFor || "-";
  const displayName = profile?.name || "—";
  const displayId = profile?._id || "";
  const displayAge = profile?.age ? `${profile.age} Years` : "—";
  const disMobileNumber = profilelist?.mobileNumber || "-";
  const displayHeight = profileInfo?.height || "—";
  const displayMarital = profileInfo?.maritalStatus || "—";
  const displaySubCaste = profileInfo?.subCaste || "—";
  const displayLanguages = profileInfo?.languagesKnown || [];
  const displayLocation = profession?.workLocation || profile?.city || "—";
  const displaymob = profile?.mobileNumber;

  const displayOccupation =
    profession?.occupation || profile?.occupation || "—";
  const displayEducation = profession?.education || profile?.education || "—";

  const fatherLabel = family?.fatherOccupation
    ? `${family?.fatherName || "—"} · ${family.fatherOccupation}`
    : family?.fatherName || "—";

  const motherLabel = family?.motherOccupation
    ? `${family?.motherName || "—"} · ${family.motherOccupation}`
    : family?.motherName || "—";

  const maskedNumber = disMobileNumber ? (
    disMobileNumber.slice(0, 3) +
    "X".repeat(Math.max(0, (disMobileNumber?.length || 0) - 3))
  ) : (
    <span style={{ fontSize: "15px" }}>XXXXXXXXX</span>
  );

  const tagItems = [
    displayMarital,
    profile?.age ? `${profile.age} Yrs` : null,
    profileInfo?.height,
    profileInfo?.subCaste,
    displayEducation !== "—" ? displayEducation : null,
  ].filter(Boolean);


  // popup 

  const [showPhotoModal, setShowPhotoModal] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [imgLoaded, setImgLoaded] = useState({});

  const photoPrev = useCallback(() => {
    setPhotoIndex(i => (i === 0 ? extraPhotos.length - 1 : i - 1));
  }, [extraPhotos.length]);

  const photoNext = useCallback(() => {
    setPhotoIndex(i => (i === extraPhotos.length - 1 ? 0 : i + 1));
  }, [extraPhotos.length]);

  const openPhotoModal = () => { setShowPhotoModal(true); setPhotoIndex(0); };
  const closePhotoModal = () => setShowPhotoModal(false);


  useEffect(() => {
    const onKey = (e) => {
      if (!showPhotoModal) return;
      if (e.key === "ArrowLeft") photoPrev();
      if (e.key === "ArrowRight") photoNext();
      if (e.key === "Escape") closePhotoModal();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [showPhotoModal, photoPrev, photoNext]);

  useEffect(() => {
    if (photoIndex >= extraPhotos.length) {
      setPhotoIndex(0);
    }
  }, [extraPhotos.length, photoIndex]);


  const handlePhotoClick = () => {
    if (!extraPhotos || extraPhotos.length === 0) {
      toast.error("Gallery images are not available");
      return;
    }
    openPhotoModal();
  };
  useEffect(() => {
    if (profile?.mobileNumber) {
      setContactNumber(profile.mobileNumber);
    }
  }, [profile]);

  const handleViewContact = async () => {
    try {
      if (loadingContact) return;

      // Already unlocked
      if (
        contactNumber &&
        !contactNumber.includes("*") &&
        !contactNumber.includes("X")
      ) {
        return;
      }

      setLoadingContact(true);

      const resultAction = await dispatch(
        viewContact({
          userId: profile._id,
        })
      );

      if (viewContact.fulfilled.match(resultAction)) {
        const data = resultAction.payload?.data;

        setContactNumber(data.mobileNumber);

        toast.success("Contact number unlocked successfully.");
      } else {
        const error = resultAction.payload;
        console.log(error)
        if (error?.code === "NO_ACTIVE_SUBSCRIPTION") {
          toast.error(error.message);

          // Navigate to plans page if you want
          // navigate("/membership");
        } else if (error?.code === "CONTACT_LIMIT_EXCEEDED") {
          toast.error(error.message);

          // Open upgrade membership modal here
          // setShowUpgradeModal(true);
        } else {
          toast.error(
            error?.message ||
            resultAction.error?.message ||
            "Unable to view contact."
          );
        }
      }
    } finally {
      setLoadingContact(false);
    }
  };



  return (
    <>
      <Container fluid>


        <div className="page">
          <div className="layout">
            <div style={{ flex: 1, minWidth: 0 }}>
              {profileLoading ? (
                <>

                  <div className="bannerCard">
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                      <div className="ep-skeleton-circle" style={{ width: 10, height: 10, borderRadius: "50%" }} />
                      <div className="ep-skeleton-line" style={{ width: "60%", height: 14 }} />
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                      <div className="ep-skeleton-line" style={{ width: 80, height: 34, borderRadius: 6 }} />
                      <div className="ep-skeleton-line" style={{ width: 120, height: 34, borderRadius: 6 }} />
                    </div>
                  </div>


                  <div className="sectionCard">
                    <div style={{ display: "flex", gap: 22, alignItems: "flex-start" }}>

                      <div style={{ flexShrink: 0 }}>
                        <div className="photoWrap">
                          <div className="ep-skeleton-avatar" style={{ width: "100%", height: "100%", borderRadius: 10 }} />
                        </div>
                        <div style={{ display: "flex", justifyContent: "center", gap: 12, marginTop: 8 }}>
                          <div className="ep-skeleton-circle" style={{ width: 20, height: 20 }} />
                          <div className="ep-skeleton-circle" style={{ width: 20, height: 20 }} />
                        </div>
                      </div>


                      <div style={{ flex: 1, minWidth: 0 }}>

                        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
                          <div className="ep-skeleton-title" style={{ width: "45%" }} />
                          <div className="ep-skeleton-line" style={{ width: 70, height: 20, borderRadius: 20 }} />
                        </div>

                        <div className="ep-skeleton-line short" style={{ width: "35%", marginBottom: 10 }} />

                        <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 14 }}>
                          <div className="ep-skeleton-line" style={{ width: 70, height: 24, borderRadius: 20 }} />
                          <div className="ep-skeleton-line" style={{ width: 85, height: 24, borderRadius: 20 }} />
                          <div className="ep-skeleton-line" style={{ width: 60, height: 24, borderRadius: 20 }} />
                          <div className="ep-skeleton-line" style={{ width: 90, height: 24, borderRadius: 20 }} />
                        </div>

                        <div className="infoGrid">
                          <div className="ep-skeleton-line" style={{ width: "80%", height: 14, marginBottom: 8 }} />
                          <div className="ep-skeleton-line" style={{ width: "70%", height: 14, marginBottom: 8 }} />
                          <div className="ep-skeleton-line" style={{ width: "75%", height: 14, marginBottom: 8 }} />
                          <div className="ep-skeleton-line" style={{ width: "65%", height: 14, marginBottom: 8 }} />
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="sectionCard" style={{ marginTop: 16 }}>
                    <div className="ep-skeleton-title" style={{ width: "40%", marginBottom: 14 }} />
                    <div className="infoGrid2">
                      <div style={{ paddingRight: 12 }}>
                        <div className="ep-skeleton-line" style={{ width: "50%", height: 12, marginBottom: 6 }} />
                        <div className="ep-skeleton-line" style={{ width: "70%" }} />
                      </div>
                      <div style={{ paddingLeft: 12, borderLeft: "0.5px solid #e5e7eb" }}>
                        <div className="ep-skeleton-line" style={{ width: "50%", height: 12, marginBottom: 6 }} />
                        <div className="ep-skeleton-line" style={{ width: "65%" }} />
                      </div>
                      <div style={{ paddingRight: 12, paddingTop: 10 }}>
                        <div className="ep-skeleton-line" style={{ width: "55%", height: 12, marginBottom: 6 }} />
                        <div className="ep-skeleton-line" style={{ width: "70%" }} />
                      </div>
                      <div style={{ paddingLeft: 12, paddingTop: 10, borderLeft: "0.5px solid #e5e7eb" }}>
                        <div className="ep-skeleton-line" style={{ width: "45%", height: 12, marginBottom: 6 }} />
                        <div className="ep-skeleton-line" style={{ width: "60%" }} />
                      </div>
                    </div>

                    <div style={{ borderTop: "0.5px solid #e5e7eb", paddingTop: 12, marginTop: 10 }}>
                      <div className="ep-skeleton-line" style={{ width: "30%", height: 12, marginBottom: 8 }} />
                      <div style={{ display: "flex", gap: 8 }}>
                        <div className="ep-skeleton-line" style={{ width: 65, height: 24, borderRadius: 20 }} />
                        <div className="ep-skeleton-line" style={{ width: 75, height: 24, borderRadius: 20 }} />
                        <div className="ep-skeleton-line" style={{ width: 55, height: 24, borderRadius: 20 }} />
                      </div>
                    </div>
                  </div>


                  <div className="sectionCard" style={{ marginTop: 16 }}>
                    <div className="ep-skeleton-title" style={{ width: "40%", marginBottom: 14 }} />
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <div className="ep-skeleton-line" style={{ width: "40%", height: 14 }} />
                      <div className="ep-skeleton-line" style={{ width: 140, height: 34, borderRadius: 6 }} />
                    </div>
                  </div>


                  <div className="sectionCard" style={{ marginTop: 16 }}>
                    <div className="ep-skeleton-title" style={{ width: "25%", marginBottom: 14 }} />
                    <div className="ep-skeleton-line" style={{ width: "100%", marginBottom: 8 }} />
                    <div className="ep-skeleton-line" style={{ width: "90%", marginBottom: 8 }} />
                    <div className="ep-skeleton-line short" style={{ width: "60%", marginBottom: 14 }} />

                    <div style={{ borderTop: "0.5px solid #e5e7eb", paddingTop: 14, marginTop: 4 }}>
                      <div className="ep-skeleton-line" style={{ width: "35%", height: 12, marginBottom: 12 }} />
                      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                        <div>
                          <div className="ep-skeleton-line" style={{ width: "45%", height: 12, marginBottom: 6 }} />
                          <div className="ep-skeleton-line" style={{ width: "70%" }} />
                        </div>
                        <div>
                          <div className="ep-skeleton-line" style={{ width: "45%", height: 12, marginBottom: 6 }} />
                          <div className="ep-skeleton-line" style={{ width: "65%" }} />
                        </div>
                        <div>
                          <div className="ep-skeleton-line" style={{ width: "50%", height: 12, marginBottom: 6 }} />
                          <div className="ep-skeleton-line" style={{ width: "75%" }} />
                        </div>
                        <div>
                          <div className="ep-skeleton-line" style={{ width: "40%", height: 12, marginBottom: 6 }} />
                          <div className="ep-skeleton-line" style={{ width: "80%" }} />
                        </div>
                      </div>
                    </div>
                  </div>


                  <div className="sectionCard" style={{ marginTop: 16 }}>
                    <div className="ep-skeleton-title" style={{ width: "45%", marginBottom: 14 }} />
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                      {Array.from({ length: 6 }).map((_, i) => (
                        <div key={i}>
                          <div className="ep-skeleton-line" style={{ width: "45%", height: 12, marginBottom: 6 }} />
                          <div className="ep-skeleton-line" style={{ width: `${60 + (i % 3) * 10}%` }} />
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {(profile?.interestReceived === "pending" ||
                    profile?.interestSent === "pending") && (
                      <div className="bannerCard">
                        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                          <div className="dot" />

                          <span style={{ fontSize: 14, color: "#374151" }}>
                            {profile?.interestReceived === "pending" ? (
                              <>
                                <b style={{ color: "#111" }}>{displayName}</b> sent you an
                                interest
                              </>
                            ) : (
                              <>
                                You have sent interest to <b>{displayName}</b>
                              </>
                            )}
                          </span>
                        </div>

                        {profile?.interestReceived === "pending" && (
                          <div style={{ display: "flex", gap: 8 }}>
                            <button className="btnDecline">Decline</button>
                            <button className="btnAccept">Accept Interest</button>
                          </div>
                        )}
                      </div>
                    )}

                  {/* PROFILE CARD */}
                  <div className="sectionCard">
                    <div style={{ display: "flex", gap: 22, alignItems: "flex-start" }}>
                      {/* PHOTO */}
                      <div style={{ flexShrink: 0 }}>
                        <div className="photoWrap" onClick={handlePhotoClick}>
                          {photos.length > 0 ? (
                            <img
                              src={photos[index]}
                              alt={displayName}
                              className="photo"
                            />
                          ) : (
                            <div className="photo photoPlaceholder">
                              <span>{displayName.charAt(0)}</span>
                            </div>
                          )}
                          {photos.length > 0 && (
                            <div className="photoCounter">
                              {index + 1}/{photos.length}
                            </div>
                          )}
                        </div>

                        {photos.length > 1 && (
                          <div style={{ display: "flex", justifyContent: "center", gap: 12, marginTop: 8 }}>
                            <IoIosArrowDropleft
                              onClick={() => setIndex((prev) => (prev === 0 ? photos.length - 1 : prev - 1))}
                              style={{ cursor: "pointer", color: "#E24B4A", fontSize: 20 }}
                            />
                            <IoIosArrowDropright
                              onClick={() => setIndex((prev) => (prev === photos.length - 1 ? 0 : prev + 1))}
                              style={{ cursor: "pointer", color: "#E24B4A", fontSize: 20 }}
                            />
                          </div>
                        )}
                      </div>

                      {/* INFO */}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div className="nameRow">
                          <h2 className="name">{displayName}</h2>
                          {displayId && (
                            <span className="idBadge">
                              {displayId.slice(-8).toUpperCase()}
                            </span>
                          )}
                        </div>
                        <p className="lastSeen">Last seen a few weeks ago</p>

                        <div className="tagRow">
                          {tagItems.map((t) => (
                            <span key={t} className="tag">
                              {t}
                            </span>
                          ))}
                        </div>

                        <div className="infoGrid">
                          <Info label="Occupation" value={displayOccupation} />
                          <Info label="Location" value={displayLocation} />
                          <Info label="Profile by" value={profileFor} />
                          <Info label="Education" value={displayEducation} />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* PERSONAL INFO */}
                  <Section title="Personal information">
                    <div className="infoGrid2">
                      <div style={{ paddingRight: 12 }} className="infoCell">
                        <Info label="Age" value={displayAge} />
                      </div>
                      <div
                        style={{ paddingLeft: 12, borderLeft: "0.5px solid #e5e7eb" }}
                        className="infoCell"
                      >
                        <Info label="Height" value={displayHeight} />
                      </div>
                      <div style={{ paddingRight: 12, paddingTop: 10 }}>
                        <Info label="Marital status" value={displayMarital} />
                      </div>
                      <div
                        style={{
                          paddingLeft: 12,
                          paddingTop: 10,
                          borderLeft: "0.5px solid #e5e7eb",
                        }}
                      >
                        <Info label="Subcaste" value={displaySubCaste} />
                      </div>
                    </div>

                    {displayLanguages.length > 0 && (
                      <div
                        style={{
                          borderTop: "0.5px solid #e5e7eb",
                          paddingTop: 12,
                          marginTop: 4,
                        }}
                      >
                        <p className="cellLabel">Languages spoken</p>
                        <div className="tagRow">
                          {displayLanguages.map((l) => (
                            <span key={l} className="tagOutline">
                              {l}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </Section>

                  <Section title="Contact information">
                    <div className="lockedRow">
                      <span
                        style={{
                          fontSize: 14,
                          color: "#6b7280",
                          letterSpacing: "0.1em",
                        }}
                      >
                        +91 {contactNumber}
                      </span>

                      <button
                        className="upgradeBtn"
                        onClick={handleViewContact}
                        disabled={loadingContact}
                      >
                        {loadingContact
                          ? "Loading..."
                          : contactNumber &&
                            !contactNumber.includes("*") &&
                            !contactNumber.includes("X")
                            ? "Contact Unlocked"
                            : "View Contact Number"}
                      </button>
                    </div>
                  </Section>

                  <Section title="About">
                    <p className="aboutText">
                      {profile?.about
                        ? profile.about
                        : `${displayName} is from ${profileInfo?.nativeDistrict || "India"}.`}
                    </p>

                    <div
                      style={{
                        borderTop: "0.5px solid #e5e7eb",
                        paddingTop: 14,
                        marginTop: 4,
                      }}
                    >
                      <p className="sectionLabel">Family background</p>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: 12,
                        }}
                      >
                        <Info label="Father" value={fatherLabel} />
                        <Info label="Mother" value={motherLabel} />
                        {family?.familyType && (
                          <Info label="Family Type" value={family.familyType} />
                        )}
                        {siblingsData.length > 0 && (
                          <div>
                            {siblingsData.length > 0 && (
                              <Info
                                label="Siblings"
                                value={siblingsData
                                  .map(
                                    (sib) =>
                                      `${sib?.name || "-"}, ${sib?.occupation || "-"}, ${sib?.maritalStatus || "-"}`,
                                  )
                                  .join(" | ")}
                              />
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </Section>

                  {(profession?.occupation ||
                    profession?.education ||
                    profession?.annualIncome ||
                    profession?.companyName) && (
                      <Section title="Professional information">
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 12,
                          }}
                        >
                          {profession?.occupation && (
                            <Info label="Occupation" value={profession.occupation} />
                          )}
                          {profession?.education && (
                            <Info label="Education" value={profession.education} />
                          )}
                          {profession?.college && (
                            <Info label="College" value={profession.college} />
                          )}
                          {profession?.companyName && (
                            <Info label="Company" value={profession.companyName} />
                          )}
                          {profession?.workLocation && (
                            <Info label="Work Location" value={profession.workLocation} />
                          )}
                          {profession?.employmentType && (
                            <Info
                              label="Employment Type"
                              value={profession.employmentType}
                            />
                          )}
                          {profession?.annualIncome && (
                            <Info label="Annual Income" value={profession.annualIncome} />
                          )}
                        </div>
                      </Section>
                    )}
                </>
              )}
            </div>

            <div className="sidebar">
              <div style={{ position: "sticky", top: 20 }} className="sectionCard">
                <p className="sectionLabel">Profiles you may like</p>
                {searchResults
                  .filter((item) => item._id !== id)
                  .slice(0, 2)
                  .map((item) => (
                    <Suggest
                      key={item._id}
                      id={item._id}
                      img={item.profilePhoto}
                      name={item.name}
                      meta={`${item.age || "-"} Yrs • ${item.profile?.height || "-"}`}
                      loc={
                        item.profession?.workLocation ||
                        item.profile?.nativeDistrict ||
                        "-"
                      }
                    />
                  ))}
              </div>
            </div>
          </div>

          {/* Gallery -- > Model Popup */}

          {showPhotoModal && (
            <div
              className="photo-modal-backdrop"
              onClick={(e) => e.target === e.currentTarget && closePhotoModal()}
            >
              <div className="photo-modal-box">


                <div className="photo-modal-header">
                  {/* <div style={{ display: "flex", alignItems: "center" }}>
                    <span className="photo-modal-title">Photo Gallery</span>
                    <span className="photo-modal-counter">
                      {photoIndex + 1} / {extraPhotos.length}
                    </span>
                  </div>*/}
                  <button className="photo-modal-close" onClick={closePhotoModal}><IoIosCloseCircle /></button>
                </div>

                {/* Carousel */}
                <div className="photo-modal-carousel">

                  {!imgLoaded[photoIndex] && <div className="photo-modal-spinner" />}
                  <img
                    key={photoIndex}
                    src={extraPhotos[photoIndex]}
                    alt={`Photo ${photoIndex + 1}`}
                    className="photo-modal-main-img"
                    style={{ opacity: imgLoaded[photoIndex] ? 1 : 0 }}
                    onLoad={() => setImgLoaded(p => ({ ...p, [photoIndex]: true }))}
                  />
                  <button className="photo-modal-nav photo-modal-prev" onClick={photoPrev}>&#8249;</button>
                  <button className="photo-modal-nav photo-modal-next" onClick={photoNext}>&#8250;</button>
                </div>

                {/* Thumbnails */}
                <div className="photo-modal-thumbs">
                  {extraPhotos.map((src, i) => (
                    <img
                      key={i}
                      src={src}
                      alt={`Thumb ${i + 1}`}
                      className={`photo-modal-thumb ${i === photoIndex ? "active" : ""}`}
                      onClick={() => setPhotoIndex(i)}
                    />
                  ))}

                </div>

                {/* Footer dots */}
                <div className="photo-modal-footer">
                  <div className="photo-modal-dots">
                    {extraPhotos.map((_, i) => (
                      <button
                        key={i}
                        className={`photo-modal-dot ${i === photoIndex ? "active" : ""}`}
                        onClick={() => setPhotoIndex(i)}
                      />
                    ))}
                  </div>
                  <span className="photo-modal-footer-label">   {extraPhotos.length > 0 ? `${photoIndex + 1} / ${extraPhotos.length}` : "0 / 0"}</span>
                </div>

              </div>
            </div>
          )}



        </div>

      </Container>
    </>
  );
}

// small components
function Section({ title, children }) {
  return (
    <div className="sectionCard">
      <p className="sectionLabel">{title}</p>
      {children}
    </div>
  );
}

// helped small component
function Info({ label, value }) {
  return (
    <div>
      <p className="cellLabel">{label}</p>
      <p className="cellValue">{value || "—"}</p>
    </div>
  );
}


function Suggest({ id, img, name, meta, loc }) {
  const navigate = useNavigate();

  return (
    <div
      className="suggestRow d-flex"
      style={{ cursor: "pointer" }}
      onClick={() => navigate(`/user/profile-details/${id}`)}
    >
      <img
        src={img || p2}
        alt={name}
        className="suggestImg"
      />

      <div>
        <p
          style={{
            fontSize: 14,
            fontWeight: 500,
            margin: "0 0 2px",
          }}
        >
          {name}
        </p>

        <p className="small">
          {meta} • {loc}
        </p>

        <span className="viewProfile">
          View profile →
        </span>
      </div>
    </div>
  );
}
